import * as React from 'react';

export function CrossIcon(): JSX.Element {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.41418 18.3848L0 16.9706L7.7782 9.1924L0 1.41422L1.41418 0L9.19238 7.77818L9.41418 7.99998L9.63599 7.77818L17.4142 0L18.8284 1.41422L11.0502 9.1924L18.8284 16.9706L17.4142 18.3848L9.63599 10.6066L9.41418 10.3848L9.19238 10.6066L1.41418 18.3848Z" fill="white" />
        </svg>
    );
}
